import strings from "assets/strings";
import Text from "components/text/Text";
import Popup from "components/popup/Popup";
import settings from "assets/mergeSettings";
import "instantsearch.css/themes/satellite.css";
import styles from "./SearchDoctors.module.scss";
import { InstantSearch } from "react-instantsearch";
import Button from "components/buttons/button/Button";
import { KeyValuePair, objectTypeProps } from "types";
import React, { useState, useEffect, useRef } from "react";
import { getAllClassNames, isDev, setParams } from "helpers";
import SvgGenerator from "components/svgGenerator/SvgGenerator";
import { AlertPopup } from "components/popup/alertPopup/AlertPopup";
import {searchClient,DOCTORS,localAttributes,algoliaAttributes,} from "assets/constants";
import { CustomCheckboxesLocal } from "components/buttons/customCheckboxesLocal/CustomCheckboxesLocal";
import { CustomLocalSearchInput } from "components/inputs/customLocalSearchInput/CustomLocalSearchInput";
import {doctorGenderOptions,visitDaysOptions,visitHoursOptions,languagesOptions,} from "assets/constants";
import SearchAdressMedicalCenters , { SearchAdressMedicalCentersHandle } from "pages/MedicalCenters/SearchMedicalCenters/SearchAdressMedicalCenters";
import {CustomDropdownCheckboxes,ItemProps,} from "components/customDropdownCheckboxes/CustomDropdownCheckboxes";
import { validateRecaptcha } from "../../../utils/recaptcha";
import { Loader } from "components/Loader/Loader";

export function SearchDoctors(props: objectTypeProps) {
  const { objectType } = props;
  const [city, setCity] = useState("");
  const [name, setName] = useState("");
  const [expanded, setExpanded] = useState(false);
  const [gender, setGender] = useState<string[]>([]);
  const [medicalField, setMedicalField] = useState("");
  const [subField, setSubField] = useState<string[]>([]);
  const [languages, setLanguages] = useState<string[]>([]);
  const [workHours, setWorkHours] = useState<string[]>([]);
  const [daysOfWeek, setDaysOfWeek] = useState<string[]>([]);
  const [subBubbles, setSubBubbles] = useState<ItemProps[]>([]);
  const [isAddressEnabled, setIsAddressEnabled] = useState(false);
  const [subMedicalFields, setSubMedicalFields] = useState<ItemProps[]>([]);
  const [selectedSubBubbles, setSelectedSubBubbles] = useState<string[]>([]);
  const [loading, setLoading] = useState(false);
  const [isMedicalFieldWithSubField, setIsMedicalFieldWithSubField] = useState(
    false
  );
  const [selectedPlace, setSelectedPlace] = useState<{
    city: string;
    lat: number | null;
    lng: number | null;
  }>({
    city: "",
    lat: null,
    lng: null,
  });
  const [isValidAddress, setIsValidAddress] = useState(false);
  const addressRef = useRef<SearchAdressMedicalCentersHandle>(null);


  const divExpandRef = useRef<HTMLDivElement>(null);
  const dropdownRef = useRef<{ focusArrow: () => void }>(null);
  const popupRef = useRef<HTMLDivElement>(null);

  let searchResultsPage: string = "";
  switch (objectType) {
    case 1:
      searchResultsPage = settings.doctorSearchResults;
      break;
    case 2:
      searchResultsPage = settings.dietSearchResults;
      break;
    case 3:
      searchResultsPage = settings.socialWorkerSearchResults;
      break;
    case 4:
      searchResultsPage = settings.medicalCenterSearchResults;
      break;
    case 5:
      searchResultsPage = settings.emergencySearchResults;
      break;
    case 6:
      searchResultsPage = settings.womenEmergencySearchResults;
      break;
    case 7:
      searchResultsPage = settings.pharmacySearchResults;
      break;
    case 8:
      searchResultsPage = settings.opticaSearchResults;
      break;
    case 9:
      searchResultsPage = settings.dentalSearchResults;
      break;
    default:
      searchResultsPage = settings.doctorSearchResults;
  }

  useEffect(() => {
    if (divExpandRef.current && expanded) {
      const firstInput = divExpandRef.current.querySelector("input");
      if (firstInput) {
        firstInput.focus();
      }
    }
  }, [expanded]);

  useEffect(() => {
    const isNameFilled = name.trim().length > 0;
  
    if (isNameFilled) {
      addressRef.current?.clear();
      setSelectedPlace({ city: "", lat: null, lng: null });
      setIsValidAddress(false);
  
      setIsAddressEnabled(false);
    }
  }, [name]);
  

  useEffect(() => {
    if (isMedicalFieldWithSubField && dropdownRef.current) {
      dropdownRef.current.focusArrow(); // Call focusArrow
    }
  }, [isMedicalFieldWithSubField]);

  useEffect(() => {
    if (!isAddressEnabled) {
      setSelectedPlace({ city: "", lat: null, lng: null });
      setIsValidAddress(false);
    }
  }, [isAddressEnabled]);

  useEffect(() => {
    const resetLoadingState = () => {
      setLoading(false);
    };

    window.addEventListener("popstate", resetLoadingState);
    window.addEventListener("pageshow", resetLoadingState);

    return () => {
      window.removeEventListener("popstate", resetLoadingState);
      window.removeEventListener("pageshow", resetLoadingState);
    };
  }, []);

  const handleToggleVisibility = () => {
    if (popupRef.current) {
      popupRef.current.classList.toggle("show");
    }
  };

  const onSubmit = async (event: any) => {
    event.preventDefault();

    const isValid = await validateRecaptcha('search_doctors');
    if (!isValid) {
      alert('אימות נכשל. נסה שוב.');
      return;
    }

    //const hasAddress =!!selectedPlace.lat && !!selectedPlace.lng && isValidAddress;
    const hasAddress=selectedPlace.lat && selectedPlace.lng && isValidAddress;

    if (objectType === 1 && !medicalField && !name) {
      handleToggleVisibility();
      return;
    }
  
    if(!hasAddress)
    {
      if (objectType !== 1 && (!city && !name)) {
        handleToggleVisibility();
        return;
      }
    }

    
      if (isAddressEnabled && !hasAddress) {
        handleToggleVisibility();
        return;
      }


    if (hasAddress) {
      const loc = `${selectedPlace.lat},${selectedPlace.lng}`;
  
      const formData: KeyValuePair[] = [
        { key: `${[localAttributes.localMedicalFieldName]}`, value: medicalField },
        {
          key: `${[localAttributes.localSubMedicalFieldNames]}`,
          value: subField.includes(strings.searchDoctors.allSubMedicalFields) ? "" : subField,
        },
        { key: `${[localAttributes.localDoctorFieldName]}`, value: name },
        { key: `${[algoliaAttributes.Gender]}`, value: gender.join(",") },
        { key: `${[localAttributes.localdaysOfWeekFieldName]}`, value: daysOfWeek.join(",") },
        { key: `${[localAttributes.localWorkHoursFieldName]}`, value: workHours.join(",") },
        { key: `${[localAttributes.localLanguagesFieldName]}`, value: languages.join(",") },
        { key: "loc", value: loc },
        { key: "r", value: "20000" },
        { key: "geo", value: "1" },
      ];
  
      setLoading(true);
      window.location.href = `${searchResultsPage}?${setParams(formData)}`;
      return;
    }



      const formData: KeyValuePair[] = [
        {
          key: `${[localAttributes.localMedicalFieldName]}`,
          value: medicalField,
        },
        {
          key: `${[localAttributes.localSubMedicalFieldNames]}`,
          value: subField.includes(strings.searchDoctors.allSubMedicalFields)
            ? ""
            : subField,
        },
        { key: `${[localAttributes.localDoctorFieldName]}`, value: name },
        { key: `${[algoliaAttributes.Gender]}`, value: gender.join(",") },
        { key: `${[localAttributes.localCityCodeFieldName]}`, value: city },
        {
          key: `${[localAttributes.localdaysOfWeekFieldName]}`,
          value: daysOfWeek.join(","),
        },
        {
          key: `${[localAttributes.localWorkHoursFieldName]}`,
          value: workHours.join(","),
        },
        {
          key: `${[localAttributes.localLanguagesFieldName]}`,
          value: languages.join(","),
        },
      ];

      if (city && city.split(",").length == 1) {
        const cities = localStorage.getItem("cities");
        const citiesArr = cities && JSON.parse(cities);
        const locLat = citiesArr.find((c: any) => c.cityCode === city)
          ?.latitude;
        const locLLong = citiesArr.find((c: any) => c.cityCode === city)
          ?.longitude;
        if (locLat && locLLong) {
          formData.push(
            {
              key: `${[localAttributes.localLocFieldName]}`,
              value: `${locLat},${locLLong}`,
            },
            { key: `${[localAttributes.localRadiusFieldName]}`, value: "20000" }
          );
        }
      }
      setLoading(true);
      window.location.href = `${searchResultsPage}?${setParams(formData)}`;
    }


  const updateSubBubbles = (bubbles: ItemProps[]) => {
    setSubBubbles(bubbles);
  };

  const handleSetSelectedCheckboxes = (subBubbles: string[]) => {
    setSelectedSubBubbles(subBubbles);
    setSubBubbles(
      subBubbles.map((item) => ({ value: item, label: item, isSelected: true }))
    );
    setSubField(subBubbles);
  };

  const handleResetField = () => {
    setMedicalField("");
    setSubMedicalFields([]);
    setSubField([]);
    setSubBubbles([]);
  };

  const handleSelectedMedicalField = (
    value: string,
    hasSubField: boolean = false
  ) => {
    if (value == undefined && !hasSubField) return;
    setMedicalField(value);
    if (value && hasSubField) {
      setIsMedicalFieldWithSubField(true);
      //setSelectedSubBubbles([strings.searchDoctors.allSubMedicalFields]);
      const medicalFields = localStorage.getItem("medicalfields");
      const medicalFieldsArr = medicalFields && JSON.parse(medicalFields);
      const subFieldsVal = medicalFieldsArr.find(
        (m: any) => m.medicalFieldName === value
      );
      const subFieldsObjects: ItemProps[] = subFieldsVal?.subMedicalFieldName.map(
        (subfield: any) => {
          return { value: subfield, label: subfield, isSelected: false };
        }
      );
      //setSubBubbles([{ value: strings.searchDoctors.allSubMedicalFields, label: strings.searchDoctors.allSubMedicalFields, isSelected: true }]);
      // setSubMedicalFields(subFieldsObjects && subFieldsObjects.length > 0 ? [{ value: strings.searchDoctors.allSubMedicalFields, label: strings.searchDoctors.allSubMedicalFields, isSelected: true }, ...subFieldsObjects] : []);
      setSubMedicalFields(
        subFieldsObjects && subFieldsObjects.length > 0 ? subFieldsObjects : []
      );
    } else {
      setIsMedicalFieldWithSubField(false);
    }
  };

  return (
    <div
      className={getAllClassNames([
        "ais-InstantSearch",
        isDev() && styles.devContainer,
        (objectType === 2 || objectType === 3) && styles.objectType3Layout, 
      ])}
    >
      <InstantSearch indexName={DOCTORS} searchClient={searchClient}>
        <div className={styles.container}>
          <div
            className={getAllClassNames([
              styles.searchDiv,
              expanded && styles.noBorderBottom,
            ])}
          >
            <div className={styles.row}>
              <CustomLocalSearchInput 
                forceReset
                popupProps={{
                  title: "",
                  subTitle: "",
                  placeholder: "",
                  keyToNormalize: "name",
                  labelToNormalize: "fullName",
                  onSubmit: () => {},
                }}
                enableFreeText
                attribute={localAttributes.localDoctorNamesApiKey}
                title={strings.searchDoctors.name}
                queryParams={[{ key: "objectType", value: objectType }]}
                onChange={(value: string) => setName(value)}
                onReset={() => setName("")}
              />

              {objectType === 1 && (
                <div className={styles.divFlex}>
                  <CustomLocalSearchInput 
                    forceReset
                    isPopup
                    popupProps={{
                      title: strings.searchDoctors.chooseMedicalField,
                      subTitle: strings.searchDoctors.canChooseMedicalField,
                      placeholder: strings.searchDoctors.searchMedicalField,
                      keyToNormalize: "medicalFieldName",
                      labelToNormalize: "medicalFieldName",
                      onSubmit: () => {},
                    }}
                    enableFreeText
                    selectedSubBubbles={subBubbles}
                    queryParams={[{ key: "objectType", value: objectType }]}
                    setSelectedSubBubbles={handleSetSelectedCheckboxes}
                    attribute={localAttributes.localMedicalApiKey}
                    title={strings.searchDoctors.medicalField}
                    onContinue={(value: string, hasSubField: boolean) => { handleSelectedMedicalField(value, hasSubField) }}

                    onChange={(value: string, hasSubField: boolean) => {
                      handleSelectedMedicalField(value, hasSubField);
                    }}
                    onReset={handleResetField}
                  />
                </div>
              )}

              {objectType === 1 && (
                <div className={styles.divFlex}>
                  {isMedicalFieldWithSubField ? ( //תת תחום
                    <CustomDropdownCheckboxes
                      ref={dropdownRef}
                      onSelected={updateSubBubbles}
                      selectedCheckBoxes={selectedSubBubbles}
                      selectOptions={subMedicalFields}
                      title={strings.searchDoctors.subField}
                      setQueryParams={(items: string[]) => setSubField(items)}
                    />
                  ) : null}
                </div>
              )}
            </div>

            <div className={styles.row}>
              <CustomLocalSearchInput
                forceReset
                multiSelect
                isPopup
                popupProps={{
                  title: strings.globalStrings.chooseCity,
                  subTitle: strings.globalStrings.canChooseCity,
                  placeholder: strings.globalStrings.searchCity,
                  keyToNormalize: "cityCode",
                  labelToNormalize: "city",
                  //filterBy: 'city',
                  onSubmit: () => {},
                }}
                placeholder={strings.globalStrings.cityPlaceholder}
                enableFreeText={!isAddressEnabled}
                showRadioButtonCheckBox={true}      
                isEnabledRadioButton={!isAddressEnabled}  
                setIsEnabledRadioButton={setIsAddressEnabled} 
                attribute={localAttributes.localCitiesApiKey}
                title={strings.globalStrings.city}
                queryParams={[{ key: "objectType", value: objectType }]}
                onChange={(value: string) => {
                  setCity(value);
                }}
                
                //onReset={() => setCity('')}
              />

              <div className={styles.addressWrap}>
         
                <SearchAdressMedicalCenters
                  ref={addressRef}
                  onPlaceSelected={(details) => {
                    setSelectedPlace({
                      city: details.city,
                      lat: details.lat,
                      lng: details.lng,
                    });
                    //setCity("");
                  }}
                  isEnabled={isAddressEnabled}
                  setIsEnabled={setIsAddressEnabled}
                  setIsValidAddress={setIsValidAddress}
                  disabled={
                    name.trim().length > 0
                  }  
                />
              </div>
            </div>
          </div>
          {expanded && (
            <div className={styles.divExpand} ref={divExpandRef}>
              <CustomCheckboxesLocal
                onSetSelected={(selectedData: string[]) => {
                  setGender(selectedData);
                }}
                title={strings.searchDoctors.doctorGender}
                options={doctorGenderOptions}
                selectedCheckboxes={gender}
              />
              <CustomCheckboxesLocal
                isFlex
                onSetSelected={(selectedData: string[]) =>
                  setDaysOfWeek(selectedData)
                }
                title={strings.globalStrings.visitDays}
                options={visitDaysOptions}
                selectedCheckboxes={daysOfWeek}
                isSpecialAriaLabel={true}
              />
              <CustomCheckboxesLocal
                onSetSelected={(selectedData: string[]) =>
                  setWorkHours(selectedData)
                }
                title={strings.globalStrings.visitHours}
                options={visitHoursOptions}
                selectedCheckboxes={workHours}
              />
              {objectType !== 2 && (
                <CustomCheckboxesLocal
                  limitWidth
                  onSetSelected={(selectedData: string[]) =>
                    setLanguages(selectedData)
                  }
                  title={strings.globalStrings.languages}
                  options={languagesOptions}
                  selectedCheckboxes={languages}
                />
              )}
            </div>
          )}
          {settings.showAdvanceSearch ? (
            <div className={styles.divBottom}>
              <div>
                <Text
                  onClick={() => setExpanded(!expanded)}
                  className={styles.textAdvance}
                  text={
                    expanded
                      ? strings.globalStrings.closeAdvancedSearch
                      : strings.globalStrings.advanceSearch
                  }
                  ariaLabel={
                    expanded
                      ? strings.globalStrings.closeAdvancedSearch
                      : strings.globalStrings.advanceSearch
                  }
                />
                {expanded ? (
                  // <ArrowUp className={styles.icon} />
                  <SvgGenerator
                    name="ArrowUp"
                    className={styles.icon}
                    objectName="doctorsSearch"
                  />
                ) : (
                  // <ArrowLeft className={styles.icon} />
                  <SvgGenerator
                    name="ArrowLeft"
                    className={styles.icon}
                    objectName="doctorsSearch"
                  />
                )}
              </div>

              <Button
                onClick={onSubmit}
                text={strings.globalStrings.search}
                replaceClassName={styles.button}
              />
            </div>
          ) : (
            <div className={styles.divBottomNoAavanced}>
              <Button
                onClick={onSubmit}
                text={strings.globalStrings.search}
                replaceClassName={styles.button}
              />
            </div>
          )}
        </div>
        {
          <Popup
            ref={popupRef}
            onClose={() => handleToggleVisibility()}
            height={284}
            width={550}
            style={{ paddingBottom: "0px" }}
          >
            <AlertPopup
              title={strings.errorMessages.notice}
              subTitle={strings.errorMessages.requiredProperties}
              showButton
              buttonText={strings.globalStrings.close}
              onClose={() => handleToggleVisibility()}
            ></AlertPopup>
          </Popup>
        }
        <Loader visible={loading} />
      </InstantSearch>
    </div>
  );
}
